import { Button } from '@deliveryhero/pd-cookbook/components/ButtonV2';
import { Grid } from '@deliveryhero/pd-cookbook/components/Grid';
import { GridItem } from '@deliveryhero/pd-cookbook/components/GridItem';
import IcEmail from '@deliveryhero/pd-cookbook/components/Icons/IcEmail';
import IcProfile from '@deliveryhero/pd-cookbook/components/Icons/IcProfile';
import { Message } from '@deliveryhero/pd-cookbook/components/Message';
import { Typography } from '@deliveryhero/pd-cookbook/components/Typography';

import { GiftCardPaymentFlow } from 'components/GiftCard//GiftCardPaymentFlow';
import { OrderSummary } from 'components/GiftCard//OrderSummary';
import { GiftCardAction } from 'components/GiftCard//types';
import { LabelText } from 'components/GiftCard/constants';
import { useFeatureFlags } from 'contexts/feature-flags';
import { Card } from 'src/components/Card';
import PaymentPending from 'src/components/svg/PaymentPending/PaymentPending';
import { FeatureFlag } from 'utils/constants';

import { GiftCardOrderConfirmationProps } from './types';

export const GiftCardOrderConfirmation = (
  props: GiftCardOrderConfirmationProps
) => {
  const featureFlags = useFeatureFlags();
  const {
    config,
    orderSummary,
    onActionClick,
    data,
    handleUpload,
    uploadState
  } = props;

  if (!data) {
    return (
      <Typography type="title-xl" color="neutral-primary">
        An error occurred. <br /> Order not placed.
      </Typography>
    );
  }

  const recipientsBox = () => {
    return data.is_distribute_myself ? (
      <>
        <IcEmail fill="neutral-secondary" />
        <Typography type="paragraph-sm" color="neutral-primary">
          Your email: <br /> {data.recipients[0]}
        </Typography>
      </>
    ) : !data.is_csv_recipients && data.recipients && data.recipients.length ? (
      <>
        <IcEmail fill="neutral-secondary" />
        <Typography type="paragraph-sm" color="neutral-primary">
          {data.recipients.slice(0, 5).map((recipient, index) => (
            <span key={index}>
              {recipient}
              <br />
            </span>
          ))}
          {data.recipients.length > 5 && (
            <span>
              {`+ ${data.recipients.length - 5} more`}
              <br />
            </span>
          )}
        </Typography>
      </>
    ) : (
      <>
        <IcProfile fill="neutral-secondary" />
        <Typography type="paragraph-sm" color="neutral-primary">
          {data.num_of_recipients}{' '}
          {data.num_of_recipients > 1 ? 'users' : 'user'}
        </Typography>
      </>
    );
  };

  const renderNewOrderConfirmationPage = () => {
    return (
      <Grid gridTemplateRows="auto auto auto" rowGap="16px">
        <GridItem>
          <GiftCardPaymentFlow
            details={config.qwikcilver_bank_details}
            id={data.order_id}
            external_order_number={data.external_order_number}
            handleUpload={handleUpload}
            uploadState={uploadState}
          />
        </GridItem>
        <Grid gridTemplateColumns="auto auto" columnGap="16px">
          <Card style={{ height: 'min-content' }}>
            <OrderSummary config={config} orderSummaryDetails={orderSummary} />
          </Card>
          <Card style={{ height: 'min-content' }}>
            <Typography type="title-md" color="neutral-primary">
              {LabelText.GIFT_CARD_ORDER_CONFIRMATION.RECIPIENTS_TITLE}
            </Typography>
            <Grid gridTemplateColumns="auto 1fr" columnGap="16px">
              {recipientsBox()}
            </Grid>
          </Card>
        </Grid>
        <GridItem>
          <Button
            layout="full-width-primary"
            type="button"
            onClick={() =>
              onActionClick(GiftCardAction.OrderConfirmation, false)
            }
          >
            {LabelText.GIFT_CARD_ORDER_CONFIRMATION.BACK_BUTTON}
          </Button>
        </GridItem>
      </Grid>
    );
  };

  {
    return featureFlags(FeatureFlag.PaymentFlow) ? (
      renderNewOrderConfirmationPage()
    ) : (
      <Grid
        gridTemplateColumns="2fr 4fr 4fr 2fr"
        columnGap="24px"
        rowGap="16px"
      >
        <Grid />
        <Grid rowGap="16px">
          <Card style={{ alignItems: 'center' }}>
            <Typography type="title-xl" color="neutral-primary">
              {LabelText.GIFT_CARD_ORDER_CONFIRMATION.PENDING_PAYMENT_TITLE}
            </Typography>
            <PaymentPending />
            <Message
              kind="warning"
              title={LabelText.GIFT_CARD_ORDER_CONFIRMATION.MESSAGE_TITLE}
              message={LabelText.GIFT_CARD_ORDER_CONFIRMATION.MESSAGE}
            />
          </Card>
        </Grid>
        <Grid rowGap="16px" gridAutoRows="max-content">
          <Card>
            <Typography type="title-md" color="neutral-primary">
              {LabelText.GIFT_CARD_ORDER_CONFIRMATION.RECIPIENTS_TITLE}
            </Typography>
            <Grid gridTemplateColumns="auto 1fr" columnGap="16px">
              {recipientsBox()}
            </Grid>
          </Card>
          <Card>
            <OrderSummary config={config} orderSummaryDetails={orderSummary} />
          </Card>
        </Grid>
        <Grid />
        <GridItem gridColumnStart={2} gridColumnEnd={4}>
          <Button
            layout="full-width-primary"
            type="button"
            onClick={() =>
              onActionClick(GiftCardAction.OrderConfirmation, false)
            }
          >
            {LabelText.GIFT_CARD_ORDER_CONFIRMATION.BACK_BUTTON}
          </Button>
        </GridItem>
      </Grid>
    );
  }
};
